export const HOME = "/";
export const LOGOUT = "/logout";
export const UNAUTHORIZED = "/unauthorized";
export const USER = "/user";
export const LANDING = "/landing";
export const MDM = "/mdm";
export const MDM_VIEW_SITES = "/mdm/view-sites";
export const MDM_IMPORT_SITES = "/mdm/import-sites";
export const MDM_IMPORT_LOGS = "/mdm/import-logs";
export const MDM_COMPILED_SITE_DATA = "/mdm/compiled-site-data";
export const PARTNER = "/partner";
export const PARTNER_VIEW_CUSTOMERS = "/partner/view-customers";
export const PARTNER_IMPORT_CUSTOMERS = "/partner/import-customers";
export const PARTNER_IMPORT_LOGS = "/partner/import-logs";
export const CONTRACT_PARAMETERS = "/contract-parameters";
export const CONTRACT_PARAMETERS_PARTNER = "/contract-parameters/partner";
export const CONTRACT_PARAMETERS_SITE = "/contract-parameters/site";
export const CONTRACT_PARAMETERS_PRODUCT = "/contract-parameters/product";
export const CONTRACT_PARAMETERS_IMPORT = "/contract-parameters/import";
export const CONTRACT_PARAMETERS_IMPORT_PARTNER =
  "/contract-parameters/import/partner";
export const CONTRACT_PARAMETERS_IMPORT_SITE =
  "/contract-parameters/import/site";
export const CONTRACT_PARAMETERS_IMPORT_PRODUCT =
  "/contract-parameters/import/product";
export const CONTRACT_PARAMETERS_IMPORT_LOGS =
  "/contract-parameters/import-logs";
export const GSAP_VOLUMES = "/gsap-volumes";
export const GSAP_VOLUMES_VOLUMES = "/gsap-volumes/volumes";
export const GSAP_VOLUMES_CORRECTION = "/gsap-volumes/correction";
export const GSAP_VOLUMES_MANUAL_CORRECTIONS =
  "/gsap-volumes/manual-corrections";
export const GSAP_VOLUMES_REBATES = "/gsap-volumes/rebates";
export const PRICING = "/pricing";
export const PRICING_FUEL_PRICES = "/pricing/fuel-prices";
export const PRICING_IMPORT_PRICES = "/pricing/import-prices";
export const PRICING_IMPORT_LOGS = "/pricing/import-logs";
export const PRICING_ADBLUE_LPG = "/pricing/adblue-lpg-prices";
export const REPORTS = "/reports";
export const REPORTS_ACCESS = "/reports/access";
export const REPORTS_GENERATE = "/reports/generate";
export const REPORTS_ACCESS_DECLARATION = "/reports/access/declaration";
export const REPORTS_ACCESS_DEALER = "/reports/access/dealer";
export const REPORTS_ACCESS_SITE_OVERVIEW = "/reports/access/site-overview";
export const REPORTS_ACCESS_DETAILED = "/reports/access/detailed";
export const REPORTS_ACCESS_REBATES = "/reports/access/rebates";
export const REPORTS_ACCESS_NEXTGEN = "/reports/access/nextgen";
export const ADMIN = "/admin";
export const PRODUCT_DATA = "/product-data";
export const REGION_DATA = "/region-data";
export const SITE_MISCELLANEOUS = "/site-miscellaneous";
export const SITE_MISCELLANEOUS_VAT_RATES = "/site-miscellaneous/vat-rates";
export const SITE_MISCELLANEOUS_PLANT_DETAILS =
  "/site-miscellaneous/plant-details";
export const SITE_MISCELLANEOUS_AUXILIARY_SITE_INFO =
  "/site-miscellaneous/auxiliary-site-info";
export const VAT_RATES = "/vat-rates";
export const PLANT_DETAILS = "/plant-details";
export const AUXILIARY_SITE_INFO = "/auxiliary-site-info";
export const FUEL_REBATES = "/fuel-discounts";
export const LOYALTY_REBATES = "/loyalty-discounts";
export const GSAP_IMPORT_VOLUMES = "/gsap-volumes/importVolumes";
export const GSAP_IMPORT_LOGS = "/gsap-volumes/importLogs";
export const PLUS_CARD = "/plus-card";
export const PLUS_CARD_CARDS = "/plus-card/cards";
export const PLUS_CARD_CARDS_IMPORT = "/plus-card/cards/import";
export const PLUS_CARD_CARDS_DOWNLOADS = "/plus-card/cards/downloads";
export const PLUS_CARD_CARDS_TANDEM_LIST = "/plus-card/cards/tandem-list";
export const PLUS_CARD_TRANSACTIONS = "/plus-card/transactions";
